import { ready } from '../../utils/functions';
import { cookieService } from './CookieService';


export class BounceWatcher {

    constructor(
        private readonly cookieName: string
    ) { }

    init(callback: () => void) {
        const isEnabled = () => !cookieService.getCookie(this.cookieName);

        if (!isEnabled()) return;

        const run = once(
            when(isEnabled,
                callback
            )
        );

        if (isMobile()) this.onGoingBack(
            run
        );

        else this.onMouseLeave(
            wait(3_000, run)
        );

        wait(10_000, run)();
    }

    disable(days: number) {
        // don't overwrite a previously created cookie
        const exists = cookieService.getCookie(this.cookieName);
        if (!exists) {
            cookieService.setCookie(this.cookieName, true, days);
        }
    }

    enable() {
        cookieService.deleteCookie(this.cookieName);
    }

    private onMouseLeave(callback: () => void) {
        // # Links
        // - https://github.com/beeker1121/exit-intent-popup/blob/master/js/bioep.js#L222
        // - https://www.thepolyglotdeveloper.com/2018/11/using-exit-intent-listener-manage-popups-page/
        // - https://github.com/AMKohn/bounceback/blob/master/lib/bounceback.js
        // FF triggers no mouseleave on document
        // Chrome triggers mouseleave only after user interaction
        document.querySelector("body").addEventListener('mouseleave', e => {
            var target = e.target as HTMLElement;
            var from = e.relatedTarget as HTMLElement;

            if (target.tagName.toLowerCase() === "input") {
                return;
            }

            var trackOnlyAbove = true;

            var isOut = !from || from.nodeName === "HTML";
            var isPos = !trackOnlyAbove || (!e.clientY || (e.clientY <= 0));
            if (isOut && isPos) {
                callback();
            }
        });
    }

    private onGoingBack(callback: () => void) {
        if (!window.history || !window.history.pushState) return;

        // manipulate browser history only after page ready, so scripts are able to skip
        ready(() => {
            const stateProp = `bounceWatcher-${this.cookieName}`;

            history.replaceState(Object.assign({}, history.state, { [stateProp]: 1 }), document.title);

            window.history.pushState({ [stateProp]: 2 }, document.title);

            window.addEventListener("popstate", e => {
                if (e.state && e.state[stateProp] === 1) {
                    callback();
                }
            });

            console.info(`registered: BounceWatcher ${this.cookieName}`);

            //function destroy() {
            //    // TODO removeEventListener('popstate')
            //    if (window.history.state[stateProp] === 2) {
            //        window.history.back();
            //    }
            //}
        });
    }
}


function isMobile() {
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase());
}


function when(condition: () => boolean, callback: () => void) {
    return () => condition() && callback();;
}

function once(callback: () => void) {
    let show = true;
    return () => {
        if (show) {
            show = false;
            callback();
        }
    };
}


function wait(delay: number, callback: () => void) {
    const start = new Date().getTime();
    return () => {
        const now = new Date().getTime();
        const delta = now - start;
        if (delta >= delay) callback();
        else setTimeout(callback, delay - delta);
    }
}
